import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  role: "list",
  class: "space-y-4 md:flex md:space-x-8 md:space-y-0 mt-14"
}
const _hoisted_2 = {
  key: 0,
  class: "group flex flex-col border-l-4 border-blue-600 py-2 pl-4 hover:border-blue-800 md:border-l-0 md:border-t-4 md:pb-0 md:pl-0 md:pt-4"
}
const _hoisted_3 = { class: "text-sm font-medium text-blue-600 group-hover:text-blue-800" }
const _hoisted_4 = { class: "text-sm font-medium" }
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col border-l-4 border-blue-600 py-2 pl-4 md:border-l-0 md:border-t-4 md:pb-0 md:pl-0 md:pt-4",
  "aria-current": "step"
}
const _hoisted_6 = { class: "text-sm font-medium text-blue-600" }
const _hoisted_7 = { class: "text-sm font-medium" }
const _hoisted_8 = {
  key: 2,
  class: "group flex flex-col border-l-4 border-gray-200 py-2 pl-4 hover:border-gray-300 md:border-l-0 md:border-t-4 md:pb-0 md:pl-0 md:pt-4"
}
const _hoisted_9 = { class: "text-sm font-medium text-gray-500 group-hover:text-gray-700" }
const _hoisted_10 = { class: "text-sm font-medium" }

import i18n from '@/plugins/i18n';



export default /*#__PURE__*/_defineComponent({
  __name: 'StepProgressIndicator',
  props: {
    step: {}
  },
  setup(__props: any) {

const props = __props;



const steps = [
  { id: i18n.global.t('add_grades_class_component.stepper.steps.step_1'), name: i18n.global.t('add_grades_class_component.stepper.circle_1.add_teacher'), status: 'complete' },
  { id: i18n.global.t('add_grades_class_component.stepper.steps.step_2'), name: i18n.global.t('add_grades_class_component.stepper.circle_2.add_grade'), status: 'current' },
  { id: i18n.global.t('add_grades_class_component.stepper.steps.step_3'), name: i18n.global.t('add_grades_class_component.stepper.circle_3.add_asssign'), status: 'upcoming' },
  { id: i18n.global.t('add_grades_class_component.stepper.steps.step_4'), name: i18n.global.t('add_grades_class_component.stepper.circle_4.review'), status: 'upcoming' },
]


return (_ctx: any,_cache: any) => {
  return (_ctx.step > 0)
    ? (_openBlock(), _createElementBlock("ol", _hoisted_1, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (stepItem, index) => {
          return _createElementVNode("li", {
            key: stepItem.name,
            class: "md:flex-1"
          }, [
            (index < _ctx.step - 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(stepItem.id), 1),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(stepItem.name), 1)
                ]))
              : (index === _ctx.step - 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(stepItem.id), 1),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(stepItem.name), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(stepItem.id), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(stepItem.name), 1)
                  ]))
          ])
        }), 64))
      ]))
    : _createCommentVNode("", true)
}
}

})